var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 243,
    viewBox: "0 0 255 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_224",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 44,
    width: 220,
    height: 199
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 44,
    width: 220,
    height: 199,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_224)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_224",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 24,
    width: 219,
    height: 219
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 24H255V243H36V24Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.299 1.51099L-26.0627 179.83L-6.60508 199.287L171.76 20.9665L152.299 1.51099",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.175 32.3789L4.8103 210.699L24.2689 230.146L202.627 51.8353L183.175 32.3789",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.177 94.3745L66.8187 272.685L86.2755 292.143L264.639 113.822L245.177 94.3745",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.054 125.234L97.6918 303.554L117.15 323.011L295.515 144.691L276.054 125.234",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.309 63.5056L35.9448 241.826L55.4025 261.274L233.762 82.9621L214.309 63.5056",
    fill: "#FFFFFE"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 105C21.7315 105 28 111.491 28 119.499C28 127.509 21.7315 134 14 134C6.26847 134 0 127.509 0 119.499C0 111.491 6.26847 105 14 105",
    fill: "#FF5493"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 52C21.7315 52 28 58.4913 28 66.4987C28 74.5087 21.7315 81 14 81C6.26847 81 0 74.5087 0 66.4987C0 58.4913 6.26847 52 14 52",
    fill: "#FF5493"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C21.7315 0 28 6.49128 28 14.4987C28 22.5087 21.7315 29 14 29C6.26847 29 0 22.5087 0 14.4987C0 6.49128 6.26847 0 14 0",
    fill: "#FF5493"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 105C81.7315 105 88 111.491 88 119.499C88 127.509 81.7315 134 74 134C66.2685 134 60 127.509 60 119.499C60 111.491 66.2685 105 74 105",
    fill: "#FF5493"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 52C81.7315 52 88 58.4913 88 66.4987C88 74.5087 81.7315 81 74 81C66.2685 81 60 74.5087 60 66.4987C60 58.4913 66.2685 52 74 52",
    fill: "#FF5493"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 0C81.7315 0 88 6.49128 88 14.4987C88 22.5087 81.7315 29 74 29C66.2685 29 60 22.5087 60 14.4987C60 6.49128 66.2685 0 74 0",
    fill: "#FF5493"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132 105C139.732 105 146 111.491 146 119.499C146 127.509 139.732 134 132 134C124.268 134 118 127.509 118 119.499C118 111.491 124.268 105 132 105",
    fill: "#FF5493"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132 52C139.732 52 146 58.4913 146 66.4987C146 74.5087 139.732 81 132 81C124.268 81 118 74.5087 118 66.4987C118 58.4913 124.268 52 132 52",
    fill: "#FF5493"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132 0C139.732 0 146 6.49128 146 14.4987C146 22.5087 139.732 29 132 29C124.268 29 118 22.5087 118 14.4987C118 6.49128 124.268 0 132 0",
    fill: "#FF5493"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlRight);
export default __webpack_public_path__ + "static/media/sl_right.6026f6272cb3a99e8d90283723ff439a.svg";
export { ForwardRef as ReactComponent };